import axios from 'axios';
import url from 'utils/url';
import Auth from './auth';
import * as Sentry from '@sentry/react';

const axiosInstance = axios.create({
    baseURL: url,
});

// axiosInstance.interceptors.response.use(
//     response => response,
//     error => {
//         const message = error?.response?.data?.message || '';
//         console.log('message', message);
//         if (
//             typeof message === 'string' &&
//             (message.toLowerCase().includes('jwt') || message.toLowerCase().includes('token'))
//         ) {
//             if (window.ReactNativeWebView) {
//                 window.ReactNativeWebView.postMessage(
//                     JSON.stringify({
//                         from: 'SET_TOKEN_SUCCESS',
//                         message:'fail'
//                     })
//                 );
//             }
//         }
//         return Promise.reject(error);
//     }
// );

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (process.env.NODE_ENV === 'production') {
            Sentry.captureException(error, {
                tags: { location: 'axiosInstance' },
                extra: {
                    method: error.config?.method,
                    url: error.config?.url,
                    status: error.response?.status,
                    data: error.response?.data,
                },
            });

            return Promise.reject(error);
        }
    }
);

const api = {
    get: async (uri, headers = {}) => {
        const commonHeaders = {
            Authorization: `Bearer ${Auth.getToken()}`,
        };
        const res = await axiosInstance.get(uri, { headers: { ...commonHeaders, ...headers } });
        return res.data;
    },
    post: async (uri, body, headers = {}) => {
        const commonHeaders = {
            Authorization: `Bearer ${Auth.getToken()}`,
        };
        const res = await axiosInstance.post(uri, body, { headers: { ...commonHeaders, ...headers } });
        return res.data;
    },
    put: async (uri, body, headers = {}) => {
        const commonHeaders = {
            Authorization: `Bearer ${Auth.getToken()}`,
        };
        const res = await axiosInstance.put(uri, body, { headers: { ...commonHeaders, ...headers } });
        return res.data;
    },
    delete: async (uri, headers = {}) => {
        const commonHeaders = {
            Authorization: `Bearer ${Auth.getToken()}`,
        };
        const res = await axiosInstance.delete(uri, { headers: { ...commonHeaders, ...headers } });
        return res.data;
    },
};

export default api;
